module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"C:\\Users\\viviane.delucca\\Workspace\\site2\\src\\layouts\\layout.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Try Consultoria","short_name":"Try","start_url":"/","display":"minimal-ui","icon":"src/images/logo-orange.svg"},
    },{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"C:\\Users\\viviane.delucca\\Workspace\\site2/src/intl","languages":["pt","en"],"defaultLanguage":"pt","redirect":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
